// Automated-test contract. Every e2e assertion reads this object — keep the
// shape in sync with tests/e2e/site.spec.ts.
export type PopariumDebug = {
  ready: boolean;
  fps: number;
  balloons: number;
  pops: number;
  ws: "offline" | "connecting" | "open" | "fallback";
  quality: "high" | "low";
  /** Dream Wing: currently active scene index, -1 elsewhere */
  scene: number;
  /**
   * Sound Hall: mean AnalyserNode bin energy, 0..1. Read straight off the live
   * audio graph so an automated check can prove the hall is actually making
   * sound rather than inferring it from pixels.
   */
  audioEnergy: number;
  /** The most recent milestone this page celebrated, 0 if none yet. */
  lastMilestone: number;
  shaderLogs: string[];
  /**
   * The Daily Pop, while its hall is open (null elsewhere). Canvas-relative
   * CSS pixels of every living target/decoy so a check can play the real
   * pointer path; `grid` is the finished day's emoji row.
   */
  daily: null | {
    number: number;
    round: number;
    phase: "intro" | "call" | "play" | "graded" | "done";
    targetsPx: [number, number][];
    decoysPx: [number, number][];
    selectedIsTarget: boolean;
    grid: string;
    practice: boolean;
  };
  /** The Bellows, while its hall is open (null elsewhere). */
  bellows: null | {
    mode: "choose" | "mic" | "hand";
    level: number;
    size: number;
    burstAt: number;
    popped: number;
  };
  /** The Music Box, while its hall is open (null elsewhere). */
  musicbox: null | {
    playing: boolean;
    /** The step last heard, -1 before the first. */
    step: number;
    /** Tines sounded since the hall opened. */
    notesPlayed: number;
    cells: number;
    token: string;
  };
};

export const dbg: PopariumDebug = {
  ready: false,
  fps: 0,
  balloons: 0,
  pops: 0,
  ws: "offline",
  quality: "high",
  scene: -1,
  audioEnergy: 0,
  lastMilestone: 0,
  shaderLogs: [],
  daily: null,
  musicbox: null,
  bellows: null,
};

declare global {
  interface Window {
    __POPARIUM__?: PopariumDebug;
  }
}

if (typeof window !== "undefined") {
  window.__POPARIUM__ = dbg;
}
